import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from '../svgs/E3_Favorite_selected.svg'

const E3FavoriteSelected: React.VFC<SvgIconProps> = props => <SvgIcon viewBox={'0 0 30 30'} component={Icon} {...props} fill="currentColor" />
export default E3FavoriteSelected
